import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import {
  IContactData,
  IOptInKey,
  IOptInPayload,
  IOptInSettings,
} from "./types";
import {
  getContactInformation,
  getContactMethods,
  getOptInSettings,
  saveOptInForm,
  validateOptInKey,
} from "../../api/services/optIn";
import { IError, LabelValue } from "../../types/common";

export const validateOptInKeyThunk = createAsyncThunk<
  IOptInKey,
  string,
  IError
>("optIn/validateOptInKey", async (key, { rejectWithValue }) => {
  try {
    const { data } = await validateOptInKey(key);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;

    return rejectWithValue(error.response?.data || { message: error.message });
  }
});

export const getContactInformationThunk = createAsyncThunk<
  IContactData,
  string,
  IError
>("optIn/getContactInformation", async (key, { rejectWithValue }) => {
  try {
    const { data } = await getContactInformation(key);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});

export const getOptInSettingsThunk = createAsyncThunk<
  IOptInSettings,
  string,
  IError
>("optIn/getOptInSettings", async (key, { rejectWithValue }) => {
  try {
    const { data } = await getOptInSettings(key);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});
export const getContactMethodsThunk = createAsyncThunk<
  LabelValue[],
  string,
  IError
>("optIn/getContactMethods", async (key, { rejectWithValue }) => {
  try {
    const { data } = await getContactMethods(key);
    return data;
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});

export const saveOptInFormThunk = createAsyncThunk<
  string,
  { key: string; payload: IOptInPayload },
  IError
>("optIn/saveOptInForm", async ({ payload, key }, { rejectWithValue }) => {
  try {
    await saveOptInForm({ payload, key });
    return "Opted-in Successfully";
  } catch (err) {
    const error = err as AxiosError<{ message: string }>;
    return rejectWithValue(error.response?.data || { message: error.message });
  }
});
